import MonixModal from "@/global/components/monix-modal";
import "./index.less"
import classNames from "classnames";
import { STATION_ITEM_TYPE, STATION_TYPE } from "@/enums/station-type";
import { useEffect, useState } from "react";
import { Input, message } from "antd";
import { Station, StationItem } from "@/global/interface/archi/station";
import genUUID from "@/global/utils/gen-uuid";
import { addStation } from "@/api/archi/station";
import localStore from "@/global/store/local-store";
import TnInput from "@/global/components/input/tn-input";
import { ReactComponent as StationFirstSvg } from '../icons/station-first.svg'
import { ReactComponent as TrackFirstSvg } from '../icons/track-first.svg'

interface Iprops {
    visible: boolean,
    setVisible: (e) => void
}
const intRegex = /^[0-9]\d*$/
export default function AddStationModal(props: Iprops) {

    // 站台类型
    const [activeStationType, setActiveStationType] = useState<number>(STATION_TYPE.STATION_FIRST)
    // 站台数量
    const [stationNum, setStationNum] = useState<number>(2)
    // 股道数量
    const [trackNum, setTrackNum] = useState<number>(1)
    // 股道分布
    const [trackDetail, setTrackDetail] = useState<number>(1)
    // 站台名称
    const [stationName, setStationName] = useState<string>("")

    useEffect(()=>{
        setActiveStationType(STATION_TYPE.STATION_FIRST)
        setStationNum(2)
        setTrackDetail(1)
        setStationName("2A+1B*1")
    },[props?.visible])

    useEffect(() => {
        if (activeStationType == STATION_TYPE.STATION_FIRST) {
            setTrackNum(stationNum - 1)
        } else {
            setTrackNum(stationNum)
        }
        setTrackDetail(null)
        setStationName(null)
    }, [stationNum, activeStationType])

    // 生成站台名称
    const generateName = () => {
        // 判断股道数量和股道分布是否正确
        if (trackDetail?.toString().length != trackNum) {
            message.error("股道分布输入错误！")
            setStationName("")
            return false
        }
        let aStr = stationNum.toString() + "A"
        let bStr = trackNum.toString() + "B*" + trackDetail
        setStationName(aStr + "+" + bStr)
        return true
    }

    // 添加站台
    const saveStation = () => {
        if (!generateName()) return
        let stationItems: StationItem[] = []
        let uuid = genUUID()

        // 获取站台列表
        for (let i = 0; i < stationNum; i++) {
            stationItems.push({
                stationId: uuid,
                type: STATION_ITEM_TYPE.STATION,
                width: 4,
                level: i + 1
            })
        }
        let trackDetailStr = trackDetail.toString()

        // 获取股道分布
        for (let i = 0; i < trackNum; i++) {
            stationItems.push({
                stationId: uuid,
                type: STATION_ITEM_TYPE.TRACK,
                count: Number(trackDetailStr.charAt(i)),
                width: Number(trackDetailStr.charAt(i)) * 2,
                level: i + 1
            })
        }

        let station: Station = {
            uuid: uuid,
            height: 1,
            length: 10,
            type: activeStationType,
            itemList: stationItems
        }

        let projectId = localStore.getProjectId()
        addStation(projectId.toString(), station).then(res => {
            message.success("添加成功!")
            props.setVisible(false)
        }).catch((e) => {
            message.error("添加失败!")
        })
    }

    // 转换站台类型按钮
    function SwitchArea() {
        return (
            <div className="switch-area">
                <div
                    className={classNames({
                        "switch-item": true,
                        "switch-item-active": activeStationType == STATION_TYPE.STATION_FIRST
                    })}
                    onClick={() => { setActiveStationType(STATION_TYPE.STATION_FIRST) }}
                >
                    站台在先
                </div>
                <div
                    className={classNames({
                        "switch-item": true,
                        "switch-item-active": activeStationType == STATION_TYPE.TRACK_FIRST
                    })}
                    onClick={() => { setActiveStationType(STATION_TYPE.TRACK_FIRST) }}
                >
                    股道在先
                </div>
            </div>
        )
    }

    return (
        <MonixModal
            title="新增站台形式"
            visible={props.visible}
            setVisible={props.setVisible}
            onSaveClick={() => { saveStation() }}
            wrapClassName="add-station-modal"
        >
            <div className="add-main">
                <div className="type-switch">
                    站台类型:
                    <SwitchArea />
                </div>
                <div className="explain">
                    {activeStationType == STATION_TYPE.STATION_FIRST ? <StationFirstSvg /> : <TrackFirstSvg />}
                </div>
                <div className="detail">
                    <div className="name-1">
                        站台数量:
                    </div>
                    <div className="station-input">
                        <TnInput
                            value={stationNum}
                            onTextChange={(e) => {
                                let value = e
                                if (intRegex.test(value)) {
                                    setStationNum(Number(value))
                                } else {
                                    setStationNum(0)
                                }
                            }}
                        />
                    </div>
                    <div className="name-2">
                        股道数量:
                    </div>
                    <div className="track-input">
                        {trackNum}
                    </div>
                    <div className="name-2">
                        股道分布:
                    </div>
                    <div className="track-detail-input">
                        <TnInput
                            className="track-detail-input"
                            value={trackDetail}
                            onTextChange={(e) => {
                                let value = e
                                if (intRegex.test(value)) {
                                    setTrackDetail(Number(value))
                                } else {
                                    setTrackDetail(0)
                                }
                            }}
                            onBlur={() => {
                                generateName()
                            }}
                        />
                    </div>
                </div>

                <div className="name-area">
                    <div className="name-title">
                        站台名称:
                    </div>
                    <div className="station-name">
                        {stationName}
                    </div>
                </div>
            </div>
        </MonixModal>
    )
}
